var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"o-debug-panel"},[_vm._v(" Real Resolution: "+_vm._s(_vm.screenWidth)+" x "+_vm._s(_vm.screenHeight)),_c('br')])}
var staticRenderFns = []

export { render, staticRenderFns }